module.exports = __webpack_public_path__ + "img/proj_hci.5ccbcb75.gif";